// extracted by mini-css-extract-plugin
export default {"bg":"styles_bg__o-GD5","section":"styles_section__TbKzo","ttl":"styles_ttl__GsHVS","txt":"styles_txt__CDQdV","cardSec":"styles_cardSec__ZmAPi"};